export const PageHeader = ({ eyebrow, title, intro, testId }) => (
  <section
    data-testid={testId}
    className="border-b border-[#0B1F33]/10 bg-[#0B1F33] py-16 lg:py-24"
  >
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="reveal max-w-3xl">
        {eyebrow && (
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#4E93F5]">
            {eyebrow}
          </p>
        )}
        <h1 className="mt-4 text-4xl font-extrabold text-white sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        {intro && (
          <p className="mt-6 text-base leading-relaxed text-white/80">{intro}</p>
        )}
      </div>
    </div>
  </section>
);

export default PageHeader;
